import { getCountry } from '@iwIntlProvider/CountryProvider';
import { getCurrentLocation } from '@iwRouter/HistoryProvider';
import { FormattedMessage } from 'react-intl';

import messages from './Navigation.messages';
import { NavLink } from './NavLink';
import { useGetNavigationData } from './useGetNavigationData';
import { FLEXI_12_URL } from '../dashboard/Dashboard.sagas';
import FallbackErrorModal from '../modals/fallbackErrorModal/FallbackErrorModal';
import { MY_OFFERS_URL } from '../myOffers/MyOffers.sagas';

export const ProductDashboardLinks = () => {
    const {
        isLoading,
        isError,
        showIwocaPay,
        showTermLoan,
        showRLS,
        showCBILS,
        showSecondCBILS,
        showFlexiLoan,
        showMyOffers,
        showRBL,
        showCreditCompass
    } = useGetNavigationData();

    const currentPath = getCurrentLocation().pathname;

    if (isLoading) {
        return (
            <div className="m-auto animate-pulse bg-structure-80 p-xs min-m:w-4xl"></div>
        );
    }
    if (isError) {
        return <FallbackErrorModal />;
    }
    return (
        <>
            {showMyOffers && (
                <NavLink
                    isActive={currentPath === MY_OFFERS_URL}
                    to={MY_OFFERS_URL}
                    data-testid="my-offers-navigation-link"
                >
                    <FormattedMessage {...messages.myOffers} />
                </NavLink>
            )}
            {showRLS && (
                <NavLink
                    isActive={currentPath === '/recovery-loan-scheme/'}
                    to="/recovery-loan-scheme/"
                    data-testid="rls-navigation-link"
                >
                    RLS
                </NavLink>
            )}
            {showIwocaPay && (
                <NavLink
                    isActive={currentPath === '/iwocapay/'}
                    to="/iwocapay/"
                    data-testid="iwocaPay-navigation-link"
                >
                    iwocaPay
                </NavLink>
            )}
            {showRBL && (
                <NavLink
                    isActive={currentPath === '/'}
                    to={'/'}
                    data-testid="rbl-navigation-link"
                >
                    {getCountry() === 'DE' ? 'eBay Flexi Kapital' : 'RBL'}
                </NavLink>
            )}
            {showCBILS && (
                <NavLink
                    isActive={currentPath === '/CBILS/'}
                    to="/CBILS/"
                    data-testid="cbils-navigation-link"
                >
                    {showSecondCBILS ? (
                        <FormattedMessage {...messages.firstCBILS} />
                    ) : (
                        <FormattedMessage {...messages.CBILSDashboard} />
                    )}
                </NavLink>
            )}
            {showSecondCBILS && (
                <NavLink
                    isActive={currentPath === '/CBILS2/'}
                    to="/CBILS2/"
                    data-testid="second-cbils-navigation-link"
                >
                    <FormattedMessage {...messages.secondCBILS} />
                </NavLink>
            )}
            {showTermLoan && (
                <NavLink
                    isActive={currentPath === '/business-loan/'}
                    to={'/business-loan/'}
                    data-testid="term-loan-navigation-link"
                >
                    Business Loan
                </NavLink>
            )}
            {showFlexiLoan && (
                <NavLink
                    isActive={currentPath === FLEXI_12_URL}
                    to={FLEXI_12_URL}
                    data-testid="flexi12-navigation-link"
                >
                    <FormattedMessage {...messages.flexi12Dashboard} />
                </NavLink>
            )}

            {showCreditCompass && (
                <button
                    className="hover:underline-offset-2link my-xs mr-l hover:underline hover:decoration-2"
                    data-testid="credit-compass-navigation-link"
                    onClick={() =>
                        window.open(
                            '/credit-compass?credit_compass_source=account_pages_navigation',
                            '_blank',
                            'noreferrer'
                        )
                    }
                >
                    <FormattedMessage
                        id="_.navigation.credit_compass_dashboard"
                        defaultMessage="Credit Compass"
                    />
                </button>
            )}
        </>
    );
};
